import { gql } from '@apollo/client';

const CREATE_KEY_TEACHER_CREATED_ACTIVITY_PREVIEW = gql`
  mutation createKeyTeacherCreatedActivityPreview($data: KeyTeacherCreatedActivityPreviewInput!) {
    createKeyTeacherCreatedActivityPreview(data: $data) {
      id
      url
    }
  }
`;

export default CREATE_KEY_TEACHER_CREATED_ACTIVITY_PREVIEW;
